<div class="modal-header">
  <h6 class="modal-title" i18n>Edit Listing Settings</h6>
  <a (click)="close()" class="cstm-close">
    <span class="far fa-times"></span>
  </a>
</div>
<div class="modal-body">
  <div *ngIf="errors.length > 0" class="info-errors">
    <i class="fal fa-exclamation-triangle"></i>
    <ng-container *ngFor="let error of errors">
      <p *ngFor="let e of error.errors">
        {{ e }}
      </p>
    </ng-container>
  </div>

  <form [formGroup]="form">
    <div class="row">
      <div class="col-sm-6">
        <mat-form-field2
          matTooltip="Select HMC ID where you want to create your listing"
          matTooltipPosition="above"
          i18n-matTooltip
          class="mat-block"
        >
          <mat-select formControlName="hmcId" placeholder="HMC ID" i18n-placeholder required>
            <mat-option *ngFor="let id of hmcIds$ | async" [value]="id">{{ id }}</mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('hmcId').touched && form.get('hmcId').hasError('required')">
            <ng-container i18n>HMC ID is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-sm-6">
        <mat-form-field2
          matTooltip="Select the numbers of Rooms from dropdown. Prepopulated with data from Rental Bedrooms field"
          matTooltipPosition="above"
          i18n-matTooltip
          class="mat-block"
        >
          <mat-select formControlName="rooms" placeholder="Rooms" i18n-placeholder required>
            <mat-option *ngFor="let q of quantities; let i = index" [value]="i + 1">{{ q }}</mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('rooms').touched && form.get('rooms').hasError('required')">
            <ng-container i18n>Rooms is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-sm-6">
        <mat-form-field2
          matTooltip="Only instant bookings are available at the moment"
          matTooltipPosition="above"
          i18n-matTooltip
          class="mat-block"
        >
          <mat-select formControlName="bookingSetting" placeholder="Booking Setting" i18n-placeholder>
            <mat-option value="instant_booking_only" i18n>Instant Booking Only</mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('bookingSetting').touched && form.get('bookingSetting').hasError('required')">
            <ng-container i18n>Booking Setting is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-sm-6">
        <mat-form-field2
          matTooltip="Language of the listing on HVMI"
          matTooltipPosition="above"
          i18n-matTooltip
          class="mat-block"
        >
          <mat-select formControlName="locale" placeholder="Locale" i18n-placeholder>
            <mat-option *ngFor="let locale of locales" [value]="locale.id">{{ locale.name }}</mat-option>
          </mat-select>
        </mat-form-field2>
      </div>
      <div class="col-sm-12">
        <mat-form-field2
          matTooltip="Select your cancellation policy"
          matTooltipPosition="above"
          i18n-matTooltip
          class="mat-block"
        >
          <mat-select formControlName="cancellationPolicyCategory" placeholder="Cancellation Policy" i18n-placeholder>
            <mat-option *ngFor="let policy of cancellationPolicies" [value]="policy.id">{{ policy.name }}</mat-option>
          </mat-select>
        </mat-form-field2>
      </div>
      <div class="col-sm-6">
        <mat-form-field2
          matTooltip="Define the number of guests included in the nightly price"
          matTooltipPosition="above"
          i18n-matTooltip
          class="mat-block"
        >
          <input
            matInput
            placeholder="Guests Included"
            i18n-placeholder
            formControlName="guestsIncluded"
            type="number"
            required
          />
          <mat-error *ngIf="form.get('guestsIncluded').touched && form.get('guestsIncluded').hasError('required')">
            <ng-container i18n>Guests Included is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-sm-6">
        <mat-form-field2 class="mat-block">
          <input matInput placeholder="Persons" i18n-placeholder formControlName="persons" type="number" required />
          <mat-error *ngIf="form.get('persons').touched && form.get('persons').hasError('required')">
            <ng-container i18n>Guests Included is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-sm-12">
        <div class="alert alert-secondary-warning">
          <i class="cs-icon cs-icon-alert-triangle alert-icon"></i>
          <div class="alert-content" i18n>
            This Guest Included value will be used on this Rental within Marriott for all bookings been made. Additional
            guest fees will not apply until the guest count on booking is greater than this Guest Included value. Rate
            specific additional guest fees threshold will not be used by Marriott. Marriott will only use this specific
            threshold set here for all rates
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <mat-form-field2
          matTooltip="Copied from the Rental but can be modified here as well"
          matTooltipPosition="above"
          i18n-matTooltip
          class="mat-block"
        >
          <textarea
            matInput
            maxlength="1000"
            rows="7"
            formControlName="shortDescription"
            placeholder="Short Description"
            i18n-placeholder
            required
            cdkTextareaAutosize
          ></textarea>
          <mat-hint align="start" i18n>Must be at least 20 and at most 1000 characters</mat-hint>
          <mat-error *ngIf="form.get('shortDescription').touched && form.get('shortDescription').hasError('required')">
            <ng-container i18n>Short Description is required</ng-container>
          </mat-error>
          <mat-error *ngIf="form.get('shortDescription').touched && form.get('shortDescription').hasError('minlength')">
            <ng-container i18n>Short Description must be at least 20 characters long</ng-container>
          </mat-error>
          <mat-error *ngIf="form.get('shortDescription').touched && form.get('shortDescription').hasError('maxlength')">
            <ng-container i18n>Short Description must be at most 1000 characters long</ng-container>
          </mat-error>
          <mat-hint align="end">{{ form.get('shortDescription').value?.length || 0 }}/1000</mat-hint>
        </mat-form-field2>
      </div>
      <div class="col-sm-12">
        <div class="text-dark" i18n>Permit / Identification Numbers</div>
        <app-form-tags2
          [items]="identificationNumberOptions"
          [formControl]="form.get('identificationNumbers')"
          [createTagFn]="addIdentificationNumber"
          [showLabel]="false"
          placeholder="Permit / Identification Numbers"
          i18n-placeholder
          class="mat-block mt5"
        ></app-form-tags2>
        <div class="text-muted text-sm mt-1" i18n>
          Enter one or more permit or registration numbers required for the property.
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-outline-light">
    <span class="far fa-times"></span>
    <ng-container i18n>Cancel</ng-container>
  </button>
  <button *ngIf="isEditing" (click)="onSave(form)" type="button" class="btn btn-secondary-info">
    <span class="cs-icon cs-icon-save"></span>
    <ng-container i18n>Save</ng-container>
  </button>
  <button *ngIf="!isEditing" (click)="onCreate(form)" type="button" class="btn btn-secondary-info">
    <span class="cs-icon cs-icon-save"></span>
    <ng-container i18n>Create</ng-container>
  </button>
</div>
